import {Component, OnInit, Inject, OnDestroy} from "@angular/core";
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from "@angular/material";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {
  CommonService,
  AlertService,
  AdminService,
  LeadService,
  ProjectService,
} from "../../_services/";
import {ToastrService} from "ngx-toastr";
import {emailList} from "../../_helper/global";
import {Subscription} from "rxjs";

import * as firebase from "firebase/app"; // Typescript
// import firebase from 'firebase/app'; // JS
import "firebase/functions";

import {environment} from "../../../environments/environment";

// Algolia
import algoliasearch from "algoliasearch";

const client = algoliasearch(
  environment.algolia.appId,
  environment.algolia.adminAPIKey
);
const index2 = client.initIndex("contacts");

@Component({
  selector: "app-add-new-event-dialog",
  templateUrl: "./add-new-event-dialog.component.html",
  styleUrls: ["./add-new-event-dialog.component.scss"],
})
export class AddNewEventDialogComponent implements OnInit {
  addEventForm: FormGroup;
  submitted = false;
  errMsg: String;
  hour12Timer: Boolean = true;
  contactList: any[] = [];
  projectList: any[] = [];
  calenderEventList: any[] = [];
  locations: any;
  addressGoogleObject = {};
  defaultLocation: "";
  showroomList: any;
  searchContacts: any[];
  selectedContactId: string;
  private subscription: Subscription;
  private subscription2: Subscription;
  private subscription3: Subscription;
  private subscription4: Subscription;
  constructor(
    public dialogRef: MatDialogRef<AddNewEventDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private _common: CommonService,
    private _alert: AlertService,
    private _admin: AdminService,
    private _toastr: ToastrService,
    private _lead: LeadService,
    private _project: ProjectService
  ) {}

  ngOnInit() {
    this.addEventForm = this.formBuilder.group({
      calendar_event_type_id: ["", [Validators.required]],
      start_date_time: ["", []],
      address: [null, []],
      showroom_id: [null, []],
      contact_id: ["", []],
      // project_id: ["", []]
    });

    // this.getProjectList();
    this.getCalenderEventTypeList();
    this.getShowroomList();
    if (firebase.apps.length < 2) {
      const app = firebase.initializeApp(environment.firebaseConfig);
      if (window.location.host.includes("localhost")) {
        app.functions().useFunctionsEmulator("http://localhost:5000");
      }
    }
    // var db = firebase.firestore();
    const loggedInEmail = localStorage.getItem("rs-email");
    if (!emailList.includes(loggedInEmail)) {
      // this.getContactList('filter');
    } else {
      // this.getContactList('all');
    }
  }

  // Search Algolia...
  searchAlgolia(form) {
    this.searchContacts = [];
    const requestOptions = {
      headers: {},
    };

    // Search Contacts...
    index2.search(form.value.contact_id, requestOptions).then(({hits}) => {
      if (form.value.keyword != "") {
        this.searchContacts = hits.map((item) => {
          return {
            first_name: item["first_name"],
            last_name: item["last_name"],
            id: item.objectID,
          };
        });
      }
    });
  }

  setContact(item) {
    this.selectedContactId = item.id;
    this.addEventForm.patchValue({
      contact_id: `${item.first_name} ${item.last_name}`,
    });
    this.searchContacts = [];
  }

  onClick(event) {
    const divSec = (<Element>event.target).className;
    if (!divSec.includes("location-area"))
      // or some similar check
      this.locations = [];
  }

  changeLocation(type) {
    const showroomControl = this.addEventForm.get("showroom_id");
    const addressControl = this.addEventForm.get("address");
    if (type === "showroom") {
      showroomControl.setValidators([Validators.required]);
      addressControl.setValidators(null);
    } else {
      addressControl.setValidators([Validators.required]);
      showroomControl.setValidators(null);
    }

    this.defaultLocation = type;
  }

  isVisible(typeVar) {
    if (this.defaultLocation === typeVar) {
      return true;
    } else {
      return false;
    }
  }

  getShowroomList() {
    this.subscription = this._admin.geShowroomList().subscribe(
      (res) => {
        this.showroomList = res;
      },
      (error) => {
        this.errMsg = error.error.message
          ? error.error.message
          : "Something went wrong!";
      }
    );
  }

  getContactList(listType) {
    if (listType === "all") {
      this.subscription2 = this._lead.getAllContacts().subscribe(
        (res) => {
          this.contactList = res;
        },
        (error) => {
          this.errMsg = error.error.message
            ? error.error.message
            : "Something went wrong!";
        }
      );
    } else {
      this.subscription3 = this._lead
        .getFilteredContacts(localStorage.getItem("uid"))
        .subscribe(
          (res) => {
            this.contactList = res;
          },
          (error) => {
            this.errMsg = error.error.message
              ? error.error.message
              : "Something went wrong!";
          }
        );
    }
  }

  // getProjectList(){
  //   this._project.getProjectList2().subscribe(res=>{
  //     this.projectList = res;
  //   },error=>{
  //     this.errMsg = error.error.message ? error.error.message :'Something went wrong!';
  //   })

  // }

  // Code to get the Calender Event Types
  getCalenderEventTypeList() {
    this._common.showLoader(true);
    this.subscription4 = this._admin.getCalenderEventTypeList().subscribe(
      (result) => {
        this._common.showLoader(false);
        this.calenderEventList = result;
      },
      (err) => {
        this._common.showLoader(false);
        this._alert.error(
          err.error.message ? err.error.message : "Something went wrong!"
        );
      }
    );
  }

  getSuggestions(event) {
    this._admin.getSuggestions(event.target.value).subscribe(
      (res) => {
        this.locations = res["data"];
      },
      (err) => {
        this._common.showLoader(false);
        this.errMsg = err.message;
      }
    );
  }

  setLocation(location) {
    this.addEventForm.patchValue({address: location.description});
    this.addressGoogleObject = location;
    this.locations = [];
  }

  hideAddEventDialog() {
    this.dialogRef.close();
  }

  get fval() {
    return this.addEventForm.controls;
  }

  onFormSubmit(): void {
    this.submitted = true;
    if (this.addEventForm.invalid) {
      return;
    }

    let form = this.addEventForm.value;
    form.uid = localStorage.getItem("uid");
    form.contact_id = this.selectedContactId ? this.selectedContactId : "";
    form.address_google = JSON.stringify(this.addressGoogleObject);
    form.start_date_time = new Date(form.start_date_time).getTime(); //JSON.stringify(form.start_date_time);
    form.end_date_time = new Date(form.start_date_time).getTime(); //JSON.stringify(form.start_date_time);
    this._common.showLoader(true);
    var functions = firebase.functions();
    let createCalenderFile = firebase
      .functions()
      .httpsCallable("create_calendar_event");
    createCalenderFile(form).then(
      (result) => {
        this._common.showLoader(false);
        this.dialogRef.close();
        this._toastr.success(`Event created successfully!`, "", {
          timeOut: 4000,
        });
      },
      (err) => {
        this._common.showLoader(false);
        this._toastr.error(
          `${
            err && err.error && err.error.message
              ? err.error.message
              : "Something went wrong!"
          }`,
          "",
          {timeOut: 4000}
        );
      }
    );
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
    if (this.subscription2) this.subscription2.unsubscribe();
    if (this.subscription3) this.subscription3.unsubscribe();
    if (this.subscription4) this.subscription4.unsubscribe();
  }
}
